import {inject, Injectable} from '@angular/core';
import {OrgOnboardingStateModel} from './state.model';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {AddOrgDetailsAction, AddOrgTeamMemberAction, CreateOrg, SetOnboardingStateOp} from './actions';
import {Navigate} from '@ngxs/router-plugin';
import {WINDOW_TOKEN} from '../../../core/tokens/window.token';

@State<OrgOnboardingStateModel>({
  name: 'orgOnboarding',
  defaults: {
    orgDetails: undefined,
    teammates: undefined,
    op: 'idle',
  }
})
@Injectable()
export class OrgOnboardingState {

  windowRef = inject(WINDOW_TOKEN);

  @Selector()
  static state({ orgDetails, teammates }: OrgOnboardingStateModel) {
    return { orgDetails, teammates };
  }

  @Selector()
  static stateOp(state: OrgOnboardingStateModel) {
    return state.op;
  }

  @Selector()
  static orgDetails(state: OrgOnboardingStateModel) {
    return state.orgDetails ?? { name: '', industry: '' };
  }

  @Selector()
  static teammates(state: OrgOnboardingStateModel) {
    return state.teammates ?? {};
  }

  @Action(AddOrgDetailsAction)
  addOrgDetailsToState({ patchState, dispatch }: StateContext<OrgOnboardingStateModel>, { payload }: AddOrgDetailsAction) {
    patchState({
      orgDetails: payload
    });
    dispatch(new Navigate(['/org/onboarding/team']));
  }

  @Action(AddOrgTeamMemberAction)
  addTeammatesToState({ patchState, dispatch }: StateContext<OrgOnboardingStateModel>, { payload }: AddOrgTeamMemberAction) {
    patchState({
      teammates: payload
    });
    dispatch(new CreateOrg());
  }

  @Action(SetOnboardingStateOp)
  restartOnSuccess({ setState }: StateContext<OrgOnboardingStateModel>, { op }: SetOnboardingStateOp) {
    const origin = this.windowRef.location.origin;
    if (op === 'success') {
      setState({ op: 'idle', orgDetails: undefined, teammates: undefined });
      this.windowRef.location.href = `${origin}/overview`;
    }
  }

}
